import { render } from "./bidItem.vue?vue&type=template&id=6979529c"
import script from "./bidItem.vue?vue&type=script&lang=js"
export * from "./bidItem.vue?vue&type=script&lang=js"

import "./bidItem.vue?vue&type=style&index=0&id=6979529c&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__